import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import * as $ from 'jquery';

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.css']
})
export class ThankyouComponent implements OnInit {

    public apiInputs = { "token":"","status":"","message":"","usertoken":"","pid":"","p_id":"","p_status":"","paramsdata":""};
    public client: any = '';
    public store: any = '';
    public token: any = '';
    public logoimage = '';
    public clientlogo = '';
    public message = '';
    public ipaddress = '';
    public status = '';
    public country = '';
    public mystatus = '';
    public currentCustomerTemp ='';
    public currentCustomer = '';
    public usertoken = '';
    public customer: any = '';
    public pid = '';
    public url = '';
    public paramsData:any='';

    constructor(
        public apiService: ApiService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService
    ) {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            if(typeof params.uid != 'undefined' && params.uid != '' && params.uid != null
            )
            {
                this.paramsData = params;
                this.usertoken = params?.uid;
                this.pid = params?.pid;
                this.message = params.message;
                if(typeof params.mystatus != 'undefined' && params.mystatus != '' && params.mystatus != null
                ){
                    this.status=params.mystatus;
                } else if(typeof params.auth != 'undefined' && params.auth != '' && params.auth != null
                ){
                    this.status=params.auth;
                }else{
                    this.status=params.status;
                }
                
                this.apiInputs.paramsdata = this.paramsData;
                this.apiInputs.status = this.status;
                this.apiInputs.token = this.usertoken;
                this.apiInputs.message = this.message;
                this.apiInputs.pid = this.pid;
                
            }
            else{
               // this.router.navigate(['not-found']);
            }
        });
    }

    ngOnInit(): void {

        this.get_feedback_list();
    }

   
    get_feedback_list():any {
       
        this.customer = this.localStorageService.getItem("currentCustomer");
        this.apiInputs.usertoken = this.customer.__zone_symbol__value;
       console.log('this.apiInputs',this.apiInputs);
       this.showLoader();
       this.apiService.postApi(this.apiInputs, 'user/updateRespondentData').subscribe((result) => {
        var result = JSON.parse(this.apiService.decode(result.successdata));
        this.hideLoader();
        if(result.status == 1){
            this.localStorageService.setItem('route', result.route);
            this.message = result.message
            decodeURI(result.url);
            window.location = result.url;

            // this.apiInputs.p_id = result.data.p_id;
            // this.apiInputs.p_status = result.data.p_status;
            // this.apiService.postApi(this.apiInputs, 'user/sendemailagaintcontinueestatus').subscribe((resultdata) => {

            // this.message = result.message
            // decodeURI(result.url); 
            // window.location = result.url;
            // },(err)=>{
            //     this.message = result.message
            //     decodeURI(result.url);
            //     window.location = result.url;
            // });

        }

    }, (err) => {
        
        this.hideLoader();
       // this.router.navigate(['not-found']);
        console.log("Client/feedback_list", JSON.stringify(err));
    });
    }

    showLoader() {
        $("#loader_form").show();
    }

    hideLoader() {
        $("#loader_form").hide();
    }
}
